import { B as p } from "./chunk-BaseElement-CJM6sCUz.js";
import { x as c } from "./chunk-lit-element-D3OkYgeM.js";
import { t as f } from "./chunk-custom-element-CN0MC8o7.js";
import { n as l } from "./chunk-property---aaewZr.js";
import { r as u } from "./chunk-state-LUQ7lD8m.js";
import { o as b } from "./chunk-query-assigned-elements-B3Bsl9Ne.js";
var d = Object.defineProperty, y = Object.getOwnPropertyDescriptor, m = (t, e, o, s) => {
  for (var r = s > 1 ? void 0 : s ? y(e, o) : e, i = t.length - 1, n; i >= 0; i--)
    (n = t[i]) && (r = (s ? n(e, o, r) : n(r)) || r);
  return s && r && d(e, o, r), r;
};
let a = class extends p {
  async _handleFormSubmit(t) {
    t.preventDefault(), await this.submitForm();
  }
  async submitForm() {
    const t = this.subscriptionForm;
    if (t) {
      const o = new FormData(t).get("email");
      if (o) {
        const s = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: o
                  }
                }
              },
              channels: ["EMAIL"]
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: "$shopify:::$default:::" + this.variantId
                }
              }
            }
          }
        }, r = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2024-06-15"
          },
          body: JSON.stringify(s)
        };
        try {
          if (!(await fetch(
            "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WuNYPi",
            r
          )).ok)
            throw new Error("Subscription failed");
          t.setAttribute("data-form-status", "success");
        } catch {
          t.setAttribute("data-form-status", "error");
        }
      }
    }
  }
  get subscriptionForm() {
    return Array.from(this.assignedElements)[0].querySelector("form");
  }
  render() {
    return c`<slot @submit=${this._handleFormSubmit}></slot>`;
  }
};
m([
  u(),
  b()
], a.prototype, "assignedElements", 2);
m([
  l({ type: String, attribute: "variant-id" })
], a.prototype, "variantId", 2);
a = m([
  f("back-in-stock-subscription-form")
], a);
export {
  a as BackInStockSubscriptionForm
};
